import ProfileViewer from "../../Universal/Profiles/ProfileViewer.component";

const NewStudentAdmission = ({ data }) => {
  return (
    <div className="w-full h-fit p-1 flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        New student arrived
      </span>
      <ProfileViewer
        _id={data?.studentId}
        name={data?.profile?.name}
        imageSource={data?.profileImage}
        imageHeight={"2.5rem"}
        imageWidth={"2.5rem"}
      />

      <div className="flex-row align-center justify-start g-05">
        <span className="poppins t-14 color-black">Time:</span>
        <span className="poppins t-14 color-grayColor">{data?.timestamp}</span>
      </div>

      {/* profile details section */}
      <div className="flex-col align-start-justify-start g-1">
        <h4 className="poppins-medium t-14 weight-500 text-align-center">
          Profile details
        </h4>
        <hr color="#DCDBDB" className="w-full" />
        <div className="scroll-y" style={{ height: "13vh" }}>
          <div className="flex-col align-start justify-start g-05">
            <div className="flex-row align-center justify-start g-05">
              <span className="poppins t-14 color-black">Name:</span>
              <span className="poppins t-14 color-grayColor">
                {data?.profile?.name}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="poppins t-14 color-black">Phone:</span>
              <span className="poppins t-14 color-grayColor">
                {data?.profile?.phone}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="poppins t-14 color-black">Email:</span>
              <span className="poppins t-14 color-grayColor">
                {data?.profile?.email}
              </span>
            </div>
          </div>
        </div>
        <hr color="#DCDBDB" className="w-full" />
      </div>
      <div className="w-full flex-col align-center justify-start g-1">
        <button type="button" className="actionBtn w-full">
          Approve
        </button>

        <button type="button" className="deleteBtnFill w-full">
          Reject
        </button>
      </div>
    </div>
  );
};

export default NewStudentAdmission;
